"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DictionaryItem_1 = require("./DictionaryItem");
const CreateDictionaryHash_1 = __importDefault(require("../cache/CreateDictionaryHash"));
class Dictionary {
    constructor(apiService, cacheService, definition, parametersValues) {
        this.id = definition.id;
        this.definition = definition;
        this._apiService = apiService;
        this._parameters = parametersValues;
        this._cacheService = cacheService;
        this._dictionaryHash = CreateDictionaryHash_1.default(this.id, this._parameters);
    }
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const query = {
                parameters: this._parameters,
            };
            const items = yield this.loadItems(query);
            this._cacheService.setItems(this._dictionaryHash, items);
            return items;
        });
    }
    getByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // get loaded items
            const cachedItems = this._cacheService.getItems(this._dictionaryHash, ids);
            const idsSet = new Set(ids);
            // remove cached items ids from identifiers for load
            for (const { id } of cachedItems) {
                idsSet.delete(id);
            }
            let items = cachedItems;
            // if cache not contain all items - load
            if (idsSet.size > 0) {
                const idsForLoad = Array.from(idsSet);
                const query = {
                    ids: idsForLoad,
                    parameters: this._parameters,
                };
                const loadedItems = yield this.loadItems(query);
                // store loaded items to cache
                this._cacheService.setItems(this._dictionaryHash, loadedItems);
                items = items.concat(loadedItems);
            }
            return items;
        });
    }
    loadItems(query) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: refactor
            const attributesMap = new Map(Object.entries(this.definition.attributes));
            const mdmResult = yield this._apiService.query(this.id, query);
            const items = mdmResult.items.map((x) => new DictionaryItem_1.DictionaryItem(x.id, attributesMap, x.attributes));
            return items;
        });
    }
    static validateParameters(definition, values = {}) {
        const dictId = definition.id;
        const paramsDefs = definition.parameters || [];
        const parametersDefsMap = new Map(Object.entries(paramsDefs));
        const valuesMap = new Map(Object.entries(values));
        if (valuesMap.size !== parametersDefsMap.size) {
            throw new Error(`Dictionary ${dictId} parameters count mistmatch ${JSON.stringify(values)}`);
        }
        parametersDefsMap.forEach((def) => {
            const parameterId = def.id;
            if (!valuesMap.has(parameterId)) {
                throw new Error(`Dictionary ${dictId} missed parameter ${parameterId} value`);
            }
        });
    }
}
exports.Dictionary = Dictionary;
//# sourceMappingURL=Dictionary.js.map